const faqs = [
    { 
        id: 1, 
        heading: 'What services do you offer?',
        content: 'We provide a range of services, including AI-driven software development, cloud computing solutions, IT consulting, cybersecurity, and custom technology solutions tailored to meet your business needs.',
    }, 
    {
        id: 2,
        heading: 'Do you provide customized solutions?',
        content: 'Absolutely! We specialize in creating custom solutions that align with your business goals, whether it\'s AI integration, scalable IT systems, or unique software applications.',
    },
    { 
        id: 3,
        heading: 'What technologies do you work with?',
        content: 'Our team is proficient in cutting-edge technologies, including Python, JavaScript, cloud platforms (AWS, Azure, Google Cloud), machine learning frameworks, and enterprise IT tools.',
    },
    {
        id: 4,
        heading: 'How long does a project take to complete?',
        content: 'Project timelines vary based on complexity and scope. After understanding your requirements, we provide a detailed roadmap with clear milestones and deadlines.',
    },
    {
        id: 5,
        heading: 'Do you offer ongoing support and maintenance?',
        content: 'Yes, we offer comprehensive post-launch support and maintenance services to ensure your systems run smoothly and remain up-to-date with the latest advancements.',
    },
];

export default faqs;